import React, { useMemo } from "react";
import InputWrapper from "./InputWrapper";
import "./ReadOnlyInput.scss";
import dayjs from "dayjs";
import { DEFAULT_DATE_FORMAT, DEFAULT_SIZE, DEFAULT_TIME_FORMAT } from "../../../utils/constant";
import PropTypes from "prop-types";

const formateDateTime = (fieldValue, type) => {
  if (!fieldValue) return "-";
  const format = type === "date" ? DEFAULT_DATE_FORMAT : DEFAULT_TIME_FORMAT;
  if (typeof fieldValue === "string") dayjs(fieldValue).format(format);
  return fieldValue.format(format);
};

const formateValue = (type, fieldValue, options) => {
  if (type !== "select" && fieldValue !== 0 && !fieldValue) return "-";
  switch (type) {
    case "number":
      return new Intl.NumberFormat().format(fieldValue);
    case "date":
      return formateDateTime(fieldValue, "date");
    case "time":
      return formateDateTime(fieldValue, "time");
    case "currency":
      return `$${new Intl.NumberFormat().format(fieldValue)}`;
    case "select":
      return options.find(opt => opt.value === fieldValue)?.label || fieldValue || "-";
    case "multiSelect":
      return fieldValue?.map(({ label }) => label).join(", ") || "-";
    case "freeSoloMultiSelect":
      return fieldValue?.map(label => label).join(", ") || "-";
    case "file":
      if (!fieldValue) return "-";
      const fileName = decodeURIComponent(fieldValue).split("?")[0].split("/").pop();
      const fileExt = fileName.split(".").pop();
      if (["png", "jpg", "jpeg", "gif"].includes(fileExt)) return <img className="proInputWrapper-read-image" src={fieldValue} alt="" />;
      return fileName;
    case "ssn":
      return fieldValue ? `XXX-XX-${fieldValue}` : "-";
    default:
      return isBlank(fieldValue) ? "-" : fieldValue;
  }
};

// checks if a string is falsy or made completely of whitespace
function isBlank(str) {
  if (typeof str === "string") {
    return !str || str.trim() === "";
  }
  return false;
}

export default function ReadOnlyInput({
  name,
  readKey,
  label,
  labelAdornment,
  options,
  readfromModel,
  type = "text",
  permission = {},
  formValues = {},
  size = DEFAULT_SIZE,
  handleReadValueClick,
  rules
}) {
  const fieldValue = useMemo(() => formValues[readKey] ?? formValues[name], [name, readKey, formValues]);
  const renderValue = useMemo(
    () => (readfromModel ? formValues[`${name}Label`] : formateValue(type, fieldValue, options)),
    [readfromModel, formValues, name, type, fieldValue, options]
  );

  const handleValueClick = () => {
    const { canEdit } = permission;
    if (canEdit) handleReadValueClick?.(name);
  };

  return (
    <InputWrapper size={size} className="proInputWrapper-read">
      <div className="proInputWrapper-read-label" style={{display: "flex", alignItems: "center", gap: "4px"}}>
        {label} {rules?.required && <span style={{ color: "red" }}> *</span>}
        {labelAdornment}
      </div>
      <div className="proInputWrapper-read-value" onClick={handleValueClick}>
        {renderValue}
      </div>
    </InputWrapper>
  );
}

ReadOnlyInput.propTypes = {
  name: PropTypes.string.isRequired,
  readKey: PropTypes.string,
  label: PropTypes.string.isRequired,
  options: PropTypes.array,
  readfromModel: PropTypes.bool,
  type: PropTypes.string,
  permission: PropTypes.shape({
    canView: PropTypes.bool,
    canAdd: PropTypes.bool,
    canEdit: PropTypes.bool
  }),
  formValues: PropTypes.object,
  size: PropTypes.string,
  handleReadValueClick: PropTypes.func,
  labelAdornment: PropTypes.node,
};
